import { Collapse, Typography } from 'antd';
import { IntlMessages } from '@/components';
import DynamicFormDataFields from '../../domains/Content/components/DynamicFormDataFields';
import React from 'react';

const { Title } = Typography;

/**
 * DynamicFormDataFieldsCollapse - Компонент для отображения необязательных динамических полей в сворачиваемом блоке
 *
 * Используется на страницах создания и редактирования динамических сущностей для группировки
 * и скрытия необязательных полей в Collapse компоненте, что улучшает UX при работе с формами.
 *
 * Особенности реализации:
 * - Содержит два идентичных блока DynamicFormDataFields - видимый и скрытый
 * - Видимый блок (display: 'block') находится внутри Collapse Panel
 * - Скрытый блок (display: 'none') находится вне Collapse
 *
 * Техническая необходимость скрытого блока:
 * Formik при инициализации должен "увидеть" все поля для корректного создания контекста формы.
 * Поля в свернутом Collapse могут быть не распознаны при первичном рендере, поэтому
 * скрытый блок гарантирует регистрацию всех необязательных полей в Formik независимо
 * от состояния Collapse.
 *
 * @param {Object} props
 * @param {Array} props.optionalFields - Массив необязательных полей шаблона
 * @param {Object} props.formikProps - Объект с пропсами Formik для управления состоянием формы
 *
 * @returns {JSX.Element} Collapse компонент с необязательными полями
 */
const DynamicFormDataFieldsCollapse = ({ optionalFields, formikProps }) => {
  return (
    <>
      {!!optionalFields.length && (
        <Collapse
          items={[
            {
              key: '1',
              label: (
                <Title level={5} className="collapse-item-title">
                  <IntlMessages id="ui-general-additional-parameters" />
                </Title>
              ),
              children: (
                <div style={{ display: 'block' }}>
                  <DynamicFormDataFields formikProps={formikProps} fields={optionalFields} />
                </div>
              ),
            },
          ]}
        ></Collapse>
      )}

      <div style={{ display: 'none' }}>
        <DynamicFormDataFields formikProps={formikProps} fields={optionalFields} />
      </div>
    </>
  );
};

export default DynamicFormDataFieldsCollapse;
